<template>
  <div class="container mt-3">
    <h1 class="text-center text-muted">Clases</h1>
    <hr>
    <div v-if="formattedClases" class="tabla">
      <v-client-table @row-click="rowClick" name="clasesTable" :columns="columns" :data="formattedClases" :options="options">
        
        <div slot="fecha" slot-scope="formattedClases">{{ formattedClases.row.fecha 
        }}<br>{{ textoHora(formattedClases.row.hora) }}</div>

        
        <div slot="salon" slot-scope="formattedClases" v-if="formattedClases.row.salon_url"> <a :href="formattedClases.row.salon_url" target="_blank">{{  formattedClases.row.salon}}</a> </div>
        <div slot="salon" slot-scope="formattedClases" v-else>{{ formattedClases.row.salon }}</div>
        
        <div slot="nombresTipos" slot-scope="formattedClases" >
          <span v-for="nombre in formattedClases.row.nombresTipos">{{ nombre }} </span>
        </div>

      </v-client-table>
    </div>
    <button class="btn btn-primary btn-sm" @click="recargar">Recargar</button>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import utils from '@/modules/utils';
  export default {
    name: 'ClasesLista',
    data () {
      return {
        columns: [ 'fecha', 'salon','nombresTipos'],
        options: {
          filterable: false,
          filterByColumn: false,
          sortable:[],
          perPage: 10,
          perPageValues: [5, 10, 15, 20],
          headings: {
            id: 'ID',
            nombresTipos: 'CLASE',
            fecha: 'FECHA',
            salon: 'SALON',
          }
        }
      }
    },
    props: {
    },
    mounted () {
        this.fetchClases()
    },
    methods:{
      ...mapActions({
        fetchClases: 'clases/fetchClases',
      }),
      ...mapMutations({

      }),
      recargar(){
        this.fetchClases().catch(()=>{}) 
      },
      textoHora(value){
        return utils.getTextoHora(value)
      },
      rowClick(event){
        this.$router.push('/clase/detalle/'+event.row.id)
      }
    },
    computed: {
      ...mapState({
        clases: state => state.clases.clases, 
      }),
      ...mapGetters({

      }),
      formattedClases(){
        let respuesta = [];
        if(this.clases && this.clases.length) {
          let ahora = new Date()
          this.clases.map(clase => {
            if(clase.id != null){
              let salon_txt = clase.salon != null?clase.salon.nombre:"";
              if(clase.salon != null ?clase.salon.numero:""){
                salon_txt = clase.salon.numero+' '+salon_txt 
              }
              let salon_url = null;
              if(clase.salon && clase.salon.url){
                salon_url = clase.salon.url 
              }
              respuesta.push({
                  id: clase.id,
                  curso: clase.curso != null?clase.curso.nombre:clase.tipo_clase,
                  fecha: clase.fecha.split('T')[0],
                  hora: clase.hora,
                  salon: salon_txt,
                  salon_url: salon_url,
                  nombresTipos: clase.nombresTipos?clase.nombresTipos:[]

              }) 
            }
          });
        }
        return respuesta;
      }
    }
  }
</script>

<style scope>

</style>